import tw from 'tailwind-styled-components'

/* Tailwind CSS components for the modal */
export const TwOverlay = tw.div`
  bg-overlay
  w-screen
  h-screen
  fixed
  top-0
  left-0
  flex
  items-center
  justify-center
`

export const TwWindow = tw.div<{
  $size: 'small' | 'medium' | 'medium-plus' | 'large'
}>`
  rounded-16
  bg-primary
  shadow-sm
  animate-scale-in
  max-h-[calc(100vh-80px)]
  overflow-hidden
  flex
  flex-col
  ${p => {
    switch (p.$size) {
      case 'small':
        return 'w-[400px]'
      case 'medium':
        return 'w-[630px]'
      case 'medium-plus':
        return 'w-[640px]'
      case 'large':
        return 'w-[800px]'
      default:
        return 'w-[630px]' // Fall back to medium size
    }
  }}
`

export const TwHeader = tw.div<{
  $showSeparator?: boolean
  $withXButton?: boolean
}>`
  pt-24
  pl-24
  flex
  flex-row
  justify-between
  ${p => (p.$withXButton ? 'pr-0' : 'pr-24')}
  ${p =>
    p.$showSeparator ? 'shadow-border-b-1 shadow-border-base pb-20' : 'pb-4'}
`

export const TwContent = tw.div<{
  $smallTopPadding?: boolean
  $smallBottomPadding?: boolean
}>`
  pl-24
  pr-24
  text-14
  font-normal
  leading-[20px]
  text-left
  overflow-y-auto
  overflow-x-hidden
  ${p => (p.$smallTopPadding ? 'pt-8' : 'pt-24')}
  ${p => (p.$smallBottomPadding ? 'pb-8' : 'pb-24')}
`

export const TwFooter = tw.footer<{
  $showSeparator?: boolean
  $colored?: boolean
}>`
  p-24
  ${p => (p.$showSeparator ? 'shadow-border-t-1 shadow-border-base' : '')}
  ${p => (p.$colored ? 'bg-header-old' : '')}
}}
`

export const TwTitle = tw.div`
  text-primary
  h2-semibold
  flex-grow-1
`

export const TwXButton = tw.div`
  text-icon-secondary
  ml-8
  mr-24
  flex-shrink-0
  flex
  flex-row
  items-center
  cursor-pointer
`
